export enum Duree {
	JOURNEE = 'JOURNEE',
	MATIN = 'MATIN',
	APRES_MIDI = 'APRES_MIDI',
}
